// TODO: Set to true to enable Entity/Trust account type selection and onboarding
export const ENTITY_SUPPORT_ENABLED = false;
